var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireplaceHeatingSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_3109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.11 1.5H3.89C2.57004 1.5 1.5 2.5678 1.5 3.885C1.5 5.2022 2.57004 6.27 3.89 6.27H20.11C21.43 6.27 22.5 5.2022 22.5 3.885C22.5 2.5678 21.43 1.5 20.11 1.5Z",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5402 6.27002H2.4502V22.5H21.5402V6.27002Z",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.0898C13.5197 10.0898 14.9772 10.6935 16.0517 11.7681C17.1263 12.8427 17.73 14.3002 17.73 15.8198V22.4998H6.27002V15.8198C6.27002 14.3002 6.87371 12.8427 7.9483 11.7681C9.02288 10.6935 10.4803 10.0898 12 10.0898Z",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8601 19.6399C14.8601 20.3984 14.5588 21.1258 14.0225 21.6622C13.4861 22.1985 12.7587 22.4999 12.0001 22.4999C11.2416 22.4999 10.5142 22.1985 9.97781 21.6622C9.44146 21.1258 9.14014 20.3984 9.14014 19.6399C9.14014 18.0499 12.0001 14.8599 12.0001 14.8599C12.0001 14.8599 14.8601 18.0499 14.8601 19.6399Z",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4298 21.0702C13.4298 21.4494 13.2792 21.8132 13.011 22.0813C12.7428 22.3495 12.3791 22.5002 11.9998 22.5002C11.6206 22.5002 11.2568 22.3495 10.9887 22.0813C10.7205 21.8132 10.5698 21.4494 10.5698 21.0702C10.5698 20.2802 11.9998 18.6802 11.9998 18.6802C11.9998 18.6802 13.4298 20.2802 13.4298 21.0702Z",
    fill: "#9393B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.549805 22.5H23.4498",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_3109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireplaceHeatingSvgrepocom);
export default __webpack_public_path__ + "static/media/fireplace-heating_svgrepo.com.b8ba5e1522076481a447532679a0295a.svg";
export { ForwardRef as ReactComponent };